import { render, staticRenderFns } from "./EventLiveBets.vue?vue&type=template&id=18bb427f"
import script from "./EventLiveBets.vue?vue&type=script&lang=js"
export * from "./EventLiveBets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports